module.exports = __webpack_public_path__ + "static/media/have-going-to-office.0c6e932e.png";